export default ".input-bg {\n  font-size: 1rem;\n  height: 33px;\n  background: #f2f3f7;\n  border-color: #f2f3f7 !important;\n  min-height: 40px;\n}";